import HttpClient from '@/libs/http';
import moxios from 'moxios';
import moment from 'moment-timezone';

const $http = new HttpClient(window.appConfig.API_BILLING_BASE_URL);

const CompanyService = {
  setJWTToken(jwt) {
    $http.setJWTToken(jwt);
  },
  removeJWTToken() {
    $http.removeJWTToken();
  },
  getCompany(payload, cb) {
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('get', '/companies/', null, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: [{
              id: 1,
              tax_id: '1234567890123',
              slug: 'haxter',
              name: 'Haxter Co., Ltd.',
              name_on_payment_card: 'บริษัท แฮกซ์เตอร์ จำกัด',
              logo: 'http://res.cloudinary.com/digit-zero/image/upload/v1524464010/scb-logo_sxjx7h.jpg',
              tel: '021234567',
              fax: '021234567',
              address: {
                line_1: '1757/29 ถนนจันทน์',
                district: 'ทุ่งมหาเมฆ',
                city: 'สาทร',
                province: 'กรุงเทพมหานคร',
                postal_code: '10120',
              },
              profiles_count: 0,
            }],
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      const url = `/companies/?query=${JSON.stringify(payload)}`;
      $http
        .sendRequest('get', url, null, null, cb);
    }
  },
  uploadCompanyLogo(file, cb) {
    const uploadUrl = `${process.env.CLOUDINARY_API_BASE_URL}${window.appConfig.CLOUDINARY_CLOUD_NAME}/upload`;
    const fd = new FormData();
    fd.append('upload_preset', window.appConfig.CLOUDINARY_UPLOAD_PRESET);
    fd.append('tags', 'browser_upload');
    fd.append('file', file);
    $http
      .sendRequest('post', uploadUrl, fd, {
        UNSET_COMMON_HEADER: true,
        'Content-Type': 'multipart/form-data',
      }, cb);
  },
  uploadOtherBankLogo(file, cb) {
    const uploadUrl = `${process.env.CLOUDINARY_API_BASE_URL}${window.appConfig.CLOUDINARY_CLOUD_NAME}/upload`;
    const fd = new FormData();
    fd.append('upload_preset', window.appConfig.CLOUDINARY_UPLOAD_PRESET);
    fd.append('tags', 'browser_upload');
    fd.append('file', file);
    $http
      .sendRequest('post', uploadUrl, fd, {
        UNSET_COMMON_HEADER: true,
        'Content-Type': 'multipart/form-data',
      }, cb);
  },
  createCompanyInfo(payload, cb) {
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('post', '/companies/', payload, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              slug: 'haxter',
              name: 'Haxter Co., Ltd.',
              name_on_payment_card: 'บริษัท แฮกซ์เตอร์ จำกัด',
              logo: 'http://res.cloudinary.com/digit-zero/image/upload/v1524464010/scb-logo_sxjx7h.jpg',
              tel: '021234567',
              fax: '021234567',
              address: {
                line_1: '1757/29 ถนนจันทน์',
                district: 'ทุ่งมหาเมฆ',
                city: 'สาทร',
                province: 'กรุงเทพมหานคร',
                postal_code: '10120',
              },
              profiles_count: 0,
            },
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http
        .sendRequest('post', '/companies/', payload, null, cb);
    }
  },
  updateCompanyInfo(payload, cb) {
    const companyId = payload.id;
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('put', `/companies/${companyId}`, payload, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              tax_id: '1234567890123',
              slug: 'haxter',
              name: 'Haxter Co., Ltd.',
              name_on_payment_card: 'บริษัท แฮกซ์เตอร์ จำกัด',
              logo: 'http://res.cloudinary.com/digit-zero/image/upload/v1524464010/scb-logo_sxjx7h.jpg',
              tel: '021234567',
              fax: '021234567',
              address: {
                line_1: '1757/29 ถนนจันทน์',
                district: 'ทุ่งมหาเมฆ',
                city: 'สาทร',
                province: 'กรุงเทพมหานคร',
                postal_code: '10120',
              },
              profiles_count: 0,
            },
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        }, 1000);
      });
    } else {
      $http
        .sendRequest('put', `/companies/${companyId}`, payload, null, cb);
    }
  },
  deleteCompanyInfo(companyId, cb) {
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('delete', `/companies/${companyId}`, null, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http
        .sendRequest('delete', `/companies/${companyId}`, null, null, cb);
    }
  },
  // COMPANY PROFILES
  getCompanyProfile(companyId, cb) {
    $http
      .sendRequest('get', `/companies/${companyId}/profiles/`, null, null, cb);
  },
  createCompanyProfile(companyId, payload, cb) {
    $http
      .sendRequest('post', `/companies/${companyId}/profiles/`, payload, null, cb);
  },
  updateCompanyProfile(profileId, payload, cb) {
    $http
      .sendRequest('put', `/profiles/${profileId}`, payload, null, cb);
  },
  deleteCompanyProfile(profileId, cb) {
    $http
      .sendRequest('delete', `/profiles/${profileId}`, null, null, cb);
  },
  getBillerCompanyProfile(cb) {
    $http
      .sendRequest('get', '/profiles/', null, null, cb);
  },
  // COMPANY ADMIN USERS
  getCompanyAdmin(companyId, cb) {
    $http
      .sendRequest('get', `/companies/${companyId}/users/`, null, null, cb);
  },
  createCompanyAdmin(companyId, payload, cb) {
    $http
      .sendRequest('post', `/companies/${companyId}/users/`, payload, null, cb);
  },
  updateCompanyAdmin(userId, payload, cb) {
    $http
      .sendRequest('put', `/users/${userId}`, payload, null, cb);
  },
  deleteCompanyAdmin(userId, cb) {
    $http
      .sendRequest('delete', `/users/${userId}`, null, null, cb);
  },
  getAdminMyAdmin(cb) {
    $http
      .sendRequest('get', '/admins/me', null, null, cb);
  },
  unblockAdminUser(adminId, cb) {
    $http
      .sendRequest('put', `/admins/${adminId}/activate`, null, null, cb);
  },
  // ADMIN USERS
  getAdminUser(cb) {
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('get', '/admins/', null, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: [{
              id: 1,
              description: 'asdfasdf',
            }],
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http
        .sendRequest('get', '/admins/', null, null, cb);
    }
  },
  createAdminUser(payload, cb) {
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('post', '/admins/', payload, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              auth_user_id: 'user-id',
              description: 'asdfasdf',
            },
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http
        .sendRequest('post', '/admins/', payload, null, cb);
    }
  },
  updateAdminUser(payload, cb) {
    const userId = payload.id;
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('put', `/admins/${userId}`, payload, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              auth_user_id: 'user-id',
              description: 'asdfasdf',
            },
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        }, 1000);
      });
    } else {
      $http
        .sendRequest('put', `/admins/${userId}`, payload, null, cb);
    }
  },
  deleteAdminUser(userId, cb) {
    // mock API
    const withMock = false;
    if (withMock) {
      moxios.install($http.getInstance());
      setTimeout(() => {
        $http
          .sendRequest('delete', `/admins/${userId}`, null, null, cb);
        moxios.wait(() => {
          const request = moxios.requests.mostRecent();
          request.respondWith({
            status: 200,
          }).then(() => {
            moxios.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http
        .sendRequest('delete', `/admins/${userId}`, null, null, cb);
    }
  },
  // BILLER
  getBillerMyAdmin(cb) {
    $http
      .sendRequest('get', '/users/me', null, null, cb);
  },
  getBillerCompany(companyId, cb) {
    $http
      .sendRequest('get', `/companies/${companyId}`, null, null, cb);
  },
  // users
  getBillerUsers(cb) {
    $http
      .sendRequest('get', '/users/', null, null, cb);
  },
  createBillerUser(companyId, payload, cb) {
    $http
      .sendRequest('post', '/users/', payload, {
        'Content-Type': 'application/json',
      }, cb);
  },
  updateBillerUser(userId, payload, cb) {
    $http
      .sendRequest('put', `/users/${userId}`, payload, {
        'Content-Type': 'application/json',
      }, cb);
  },
  unblockBillerAdmin(userId, cb) {
    $http
      .sendRequest('put', `/users/${userId}/activate`, null, null, cb);
  },
  // Slips
  /* eslint no-param-reassign: 0 */
  getBillerSlips({ profileId, payload }, cb) {
    // adjust payload value
    const dueDateFrom = moment(payload.issued_on__from).tz(process.env.DEFAULT_TZ);
    const dueDateTo = moment(payload.issued_on__to).tz(process.env.DEFAULT_TZ);
    if (dueDateFrom.isValid()) {
      payload.issued_on__from = dueDateFrom.format('YYYY-MM-DD');
    }
    if (dueDateTo.isValid()) {
      payload.issued_on__to = dueDateTo.format('YYYY-MM-DD');
    }
    const url = `/profiles/${profileId}/slips/?query=${JSON.stringify(payload)}`;
    /* $http
      .sendRequest('get', url, null, null, cb); */
    $http
      .getInstance()
      .request({ url, method: 'GET' })
      .then((res) => {
        const data = $http.getResponseData(res) || {total: 0, slips:[]};
        // const total = Number(res.headers['x-total']) || data.length;
        // console.log(data, res)
        cb(null, { total: Number(data.total), data: data.slips });
      })
      .catch((err) => {
        cb($http.getErrorData(err), null);
      });
  },
  createBillerSlip(profileId, payload, cb) {
    $http
      .sendRequest('post', `/profiles/${profileId}/slips/`, payload, null, cb);
  },
  updateBillerSlip(slipId, payload, cb) {
    $http
      .sendRequest('put', `/slips/${slipId}`, payload, null, cb);
  },
  deleteBillerSlip(slipId, cb) {
    $http
      .sendRequest('delete', `/slips/${slipId}`, null, null, cb);
  },
  printPayerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: `/profiles/${profileId}/print-orders/`,
      method: 'put',
      timeout: 60000,
      headers: {
        Accept: 'application/pdf',
        'content-type': 'application/json',
      },
      data: {
        slip_ids: slips,
      },
      responseType: 'arraybuffer',
    }).then((res) => {
      cb(null, $http.getResponseData(res));
    }).catch((err) => {
      cb($http.getErrorData(err), null);
    });
  },
  emailPayerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: `/profiles/${profileId}/email-orders/`,
      method: 'put',
      timeout: 60000,
      headers: {
        'content-type': 'application/json',
      },
      data: {
        slip_ids: slips,
      },
    }).then((res) => {
      cb(null, $http.getResponseData(res));
    }).catch((err) => {
      cb($http.getErrorData(err), null);
    });
  },
  printPayerQR(profileId, slips, cb) {
    const type = slips.length > 1 ? 'application/octet-stream' : 'image/png';
    $http.getInstance().request({
      url: `/profiles/${profileId}/print-orders/qr-img/`,
      method: 'put',
      timeout: 60000,
      headers: {
        Accept: type,
        'content-type': 'application/json',
      },
      data: {
        slip_ids: slips,
      },
      responseType: 'arraybuffer',
    }).then((res) => {
      cb(null, $http.getResponseData(res));
    }).catch((err) => {
      cb($http.getErrorData(err), null);
    });
  },
  emailPayerQR(profileId, slips, cb) {
    $http.getInstance().request({
      url: `/profiles/${profileId}/email-orders/qr-img/`,
      method: 'put',
      timeout: 60000,
      headers: {
        'content-type': 'application/json',
      },
      data: {
        slip_ids: slips,
      },
    }).then((res) => {
      cb(null, $http.getResponseData(res));
    }).catch((err) => {
      cb($http.getErrorData(err), null);
    });
  },
  deletePayerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: `/profiles/${profileId}/delete-orders/`,
      method: 'put',
      headers: {
        'content-type': 'application/json',
      },
      data: {
        slip_ids: slips,
      },
    }).then((res) => {
      cb(null, $http.getResponseData(res));
    }).catch((err) => {
      cb($http.getErrorData(err), null);
    });
  },
  importBillerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: `/profiles/${profileId}/upsert-slips-orders/`,
      method: 'put',
      timeout: 60000,
      headers: {
        'content-type': 'application/json',
      },
      data: {
        slips,
      },
    }).then((res) => {
      cb(null, $http.getResponseData(res));
    }).catch((err) => {
      cb($http.getErrorData(err), null);
    });
  },
};

export default CompanyService;



// WEBPACK FOOTER //
// ./src/services/company.js